import Modal from 'react-bootstrap/Modal';
import { useTranslation } from "react-i18next";

export const ModalWarning = (props) => {
  const { t } = useTranslation();
  return (<Modal show={props.show} onHide={() => props.onProceed()} centered>
          <Modal.Header closeButton>
            <Modal.Title>{props.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {props.message}
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="standalone-button btn btn-primary"
              onClick={() => props.onProceed()}>
              {t('ok')}
            </button>
          </Modal.Footer>
        </Modal>)
}